import { CompanySubtypeTagsForm } from './CompanySubtypeTagsForm';

const CompanyTagsForm = () => <CompanySubtypeTagsForm source="team" />;

export default CompanyTagsForm;
